var _rect, _rect2, _rect3, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIran(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 630,
    height: 360,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 630,
    height: 360,
    fill: "#da0000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 630,
    height: 240,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 630,
    height: 120,
    fill: "#239f40"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.4,100.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tb4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tb1",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    id: "tbp1",
    d: "M0,1H26M1,10V5H9V9H17V5H12M4,9H6M26,9H21V5H29M29,0V9H37V0M33,0V9",
    transform: "scale(1.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tbp2",
    d: "M0,7H9M10,7H19",
    transform: "scale(2.8)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tbp2",
    y: 120
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tbp1",
    y: 145.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "tb3"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tb1",
    x: 56
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tb1",
    x: 112
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tb1",
    x: 168
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tb3",
    x: 168
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tb4",
    x: 392
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#da0000",
    transform: "matrix(45,0,0,45,315,180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "emblem_half"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.54815,0.83638A0.912046,0.912046 0 0,0 0.328544,-0.722384A1,1 0 0,1 -0.54815,0.83638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.618339,0.661409A0.763932,0.763932 0 0,0 0.421644,-0.741049A1,1 0 0,1 0.618339,0.661409"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1 -0.05,0 0,-0.787278A0.309995,0.309995 0 0,0 0.118034,-0.688191V-0.100406L0.077809,0.892905z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.02,-0.85 0,-0.831217A0.14431,0.14431 0 0,0 0.252075,-0.967708A0.136408,0.136408 0 0,1 0,-0.924634"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#emblem_half",
    transform: "scale(-1,1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIran);
export default __webpack_public_path__ + "static/media/Iran.4c6f626dadb69089cd7632c4dbc736a6.svg";
export { ForwardRef as ReactComponent };